import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CustomOrder } from '@order/const';
import { Observable } from 'rxjs';
import { OrderDetailsComponentService } from '../order-details.component-service';

@Component({
  selector: 'sd-order-details-actions',
  templateUrl: './order-detail-actions.component.html',
  styleUrls: ['./order-detail-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCustomOrderDetailActionsComponent {
  order$: Observable<CustomOrder> = this.orderDetailsComponentService.getOrderDetails();

  constructor(private orderDetailsComponentService: OrderDetailsComponentService) {}
}
